import { ParteAlteracao } from "../../types";
import CardParteProcessoEditada from "./CardParteProcessoEditada";
import CardParteRepresentadaEditada from "./CardParteRepresentadaEditada";
import styled from "styled-components";

const ParteWrapper = styled.div`
    /* Espaçamento controlado pelo gap do .partes-container */
`;

interface BlocoPartesProps {
    partes: ParteAlteracao[];
}

export default function BlocoPartes({ partes }: BlocoPartesProps) {
    if (partes.length === 0) {
        return null;
    }

    return (
        <div className="expanded-section">
            <h4 className="section-title">Partes</h4>
            <div className="partes-container">
                {partes.map((parteAlteracao, idx) => {
                    const key = `${parteAlteracao.tipo}-${parteAlteracao.parte.nome}-${idx}`;
                    const isParteRepresentada = parteAlteracao.parte.tipo === 'PARTE REPRESENTADA';
                    
                    const parteParaCard = {
                        tipo: parteAlteracao.parte.tipo || (isParteRepresentada ? 'PARTE REPRESENTADA' : ''),
                        nome: parteAlteracao.parte.nome,
                        representada: parteAlteracao.parte.representada ?? false
                    };
                    
                    return (
                        <ParteWrapper key={key} className="parte-item">
                            {isParteRepresentada ? (
                                <CardParteRepresentadaEditada 
                                    parte={parteParaCard} 
                                    tipoAlteracao={parteAlteracao.tipo}
                                />
                            ) : (
                                <CardParteProcessoEditada 
                                    parte={parteParaCard} 
                                    tipoAlteracao={parteAlteracao.tipo}
                                />
                            )}
                        </ParteWrapper>
                    );
                })}
            </div>
        </div>
    );
}

